import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { SurchargeTemplatesComponent } from './surcharge-templates.component';

const routes: Routes = [
  { path: '', component: SurchargeTemplatesComponent, canActivate: [AuthGuard] },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SurchargeTemplatesRoutingModule { }
